/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, November 6th 2022, 8:58:44 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APISERVICEPATHS, useAPIRequest, useAPIForm, UseAPIFormSpec } from "lib/api";
import { AjaxSource, AjaxSourceValidationSchema } from "lib/schemas";

const remoteDatasetsAPIServicePath = APISERVICEPATHS.remoteDatasets;

interface UseRemoteDatasetFormSpec {
  ajaxSourceId: AjaxSource["id"];
  ajaxSourceDefault: AjaxSource;
  updateAjaxSourceFromAPICallback: UseAPIFormSpec<AjaxSource>["setAPIFormResponse"];
  onSaveAjaxSource: UseAPIFormSpec<AjaxSource>["onSaveAPIItem"];
}

export const useRemoteDatasetsAPI = () => ({
  useList: () =>
    useAPIRequest<AjaxSource[]>({
      apiServicePath: remoteDatasetsAPIServicePath,
      makeRequestOnInitialMount: false,
    }),
  useAjaxSourceAPIForm: (args: UseRemoteDatasetFormSpec) => {
    return useAPIForm({
      apiServicePath: remoteDatasetsAPIServicePath,
      apiFormDataValidationSchema: AjaxSourceValidationSchema,
      apiFormDefaultValues: args?.ajaxSourceDefault,
      apiInitialFetchId: args?.ajaxSourceId,
      primaryKey: "id",
      setAPIFormResponse: args?.updateAjaxSourceFromAPICallback,
      onSaveAPIItem: args?.onSaveAjaxSource,
    });
  },
});
